<template>
  <el-form label-position="top" ref="form" :model="form" class="text-left">
    <el-row :gutter="30">
      <el-col :span="24" :sm="14" :md="12">
        <el-form-item label="ชื่อผู้มีสิทธิ์ลงนามในใบประกาศนียบัตร">
          <el-input v-model="form.signName"></el-input>
        </el-form-item>
        <el-form-item label="ตำแหน่งผู้มีสิทธิ์ลงนามในใบประกาศนียบัตร">
          <el-input v-model="form.position"></el-input>
        </el-form-item>
        <el-form-item label="อัพโหลดรูปภาพลายเซ็น (ขนาด 500x450 px)">
          <el-upload
            v-if="!form.signatureimage"
            class="upload-input-text"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="uploadSignatureImage"
          >
            <template slot="trigger">
              <div class="flex-display">
                <el-input class></el-input>
                <el-button type="primary" class="light mg-l-4"
                  >แนบไฟล์</el-button
                >
              </div>
            </template>
          </el-upload>

          <div
            v-else
            class="image-preview"
            :style="'background-image:url(' + getUrlImage() + ');'"
          >
            <i
              @click="closeImage"
              class="fas fa-times-circle icon-preview-image"
            ></i>
          </div>
        </el-form-item>
        <div class="text-center pd-y-3">
          <el-button
            @click="updateGeneral"
            type="primary"
            round
            class="pd-x-1"
            >บันทึก</el-button
          >
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      default() {
        return null;
      },
    },
    name: {
      type: String,
      default() {
        return "";
      },
    },
    position: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      form: {
        signName: "",
        position:"",
        signatureimage: "",
      },
      usrlSystem: process.env.VUE_APP_BASE_URL_SYSTEM,
    };
  },
  watch: {
    image() {
      this.setImags();
    },
  },
  mounted() {
    this.setImags();
  },
  methods: {
    setImags() {
      this.form = {
        signName: this.name,
        position:this.position,
        signatureimage:this.image && this.image.file?this.image.file:'',
        delSignature:''
      };
    },
    uploadSignatureImage(file) {
      this.form.signatureimage = file.raw
    },
    closeImage() {
      this.form.delSignature = this.image.file
      this.form.signatureimage = ''
    },
    getUrlImage() {
      if (typeof this.form.signatureimage.uid != 'undefined') {
        return URL.createObjectURL(this.form.signatureimage);
      }else if (this.form.signatureimage) {
        return `${this.usrlSystem}${this.image.file}`;   
      }else{
        return ''
      }
    },
    updateGeneral(){
      this.$emit("saveGeneralInfornation",this.form);
    }
  },
};
</script>

<style scoped>
.image-preview {
  width: 100%;
  min-height: 300px;

  background-repeat: no-repeat;
  background-position: center center;
  background-size: auto;
  border-radius: 5px;
  position: relative;
}
.icon-preview-image {
  position: absolute;
  right: -4px;
  top: -4px;
  color: #c4c4c4;
  cursor: pointer;
  background: #fff;
  border-radius: 20px;
}
</style>
